export const crmKeys = {
  all: ['crm'] as const,
  pipeline: (p: {
    mineOnly?: boolean;
    managerId?: number | null;
    includeUnassigned?: boolean;
    crmDepartment?: string | null;
  }) => [...crmKeys.all, 'pipeline', p] as const,
  myDay: (managerId?: number | null) => [...crmKeys.all, 'my-day', managerId ?? 'self'] as const,
  intake: (p: { managerId?: number | null }) => [...crmKeys.all, 'intake', p] as const,
  alerts: (p: { managerId?: number | null }) => [...crmKeys.all, 'alerts', p] as const,
  insights: (p: { days: number; managerId?: number | null }) => [...crmKeys.all, 'insights', p] as const,
  orderActivities: (orderId: number) => [...crmKeys.all, 'activities', 'order', orderId] as const,
  leadActivities: (leadId: number) => [...crmKeys.all, 'activities', 'lead', leadId] as const,
  orderTasks: (orderId: number) => [...crmKeys.all, 'tasks', 'order', orderId] as const,
  leadTasks: (leadId: number) => [...crmKeys.all, 'tasks', 'lead', leadId] as const,
  clientActivities: (userId: number) => [...crmKeys.all, 'activities', 'client', userId] as const,
};
